import { DEFAULT_REGION, REGION_ALLOWED_PATHS } from 'shared/components/RegionSwitcher/constants';
import { PRODUCTS_LIST_PATH } from 'shared/constants/routes';
import { sidebarItems } from 'components/molecules/LeftSidebar/constants';
import { ACTIVITY_LIST_PATH } from 'routing/routes/activity/constants';
import { COUPONS_LIST_PATH } from 'routing/routes/coupons/constants';
import { PLANS_LIST_PATH } from 'routing/routes/customPlansManagement/constants';
import { DISTRIBUTORS_LIST_PATH } from 'routing/routes/distributors/constants';
import { MEMBERS_LIST_PATH } from 'routing/routes/members/constants';
import { ORGANIZATIONS_LIST_PATH } from 'routing/routes/organizations/constants';
import { PARTNERS_PATH } from 'routing/routes/partners/constants';
import { REFUNDS_LIST_PATH } from 'routing/routes/refunds/constants';
import { RESELLERS_LIST_PATH } from 'routing/routes/resellers/constants';
import { USERS_ROLES_LIST_PATH } from 'routing/routes/roles/constants';
import { SERVER_LIST_PATH } from 'routing/routes/servers/constants';
import { USERS_LIST_PATH, USERS_MANAGEMENT_PATH } from 'routing/routes/users/constants';
// Used for list-type path check in isListPage
var NAVIGATION_PATHS = [PRODUCTS_LIST_PATH, ACTIVITY_LIST_PATH, COUPONS_LIST_PATH, PLANS_LIST_PATH, DISTRIBUTORS_LIST_PATH, MEMBERS_LIST_PATH, ORGANIZATIONS_LIST_PATH, PARTNERS_PATH, REFUNDS_LIST_PATH, RESELLERS_LIST_PATH, USERS_ROLES_LIST_PATH, SERVER_LIST_PATH, USERS_LIST_PATH, USERS_MANAGEMENT_PATH];
var normalizePath = function normalizePath(path) {
    return path.replace(/\/$/, '');
};
export var isPathAllowedForRegion = function isPathAllowedForRegion(pathname) {
    var region = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_REGION;
    var allowedPaths = REGION_ALLOWED_PATHS[region];
    if (!allowedPaths) {
        return true;
    }
    var currentPath = normalizePath(pathname);
    return allowedPaths.some(function (allowedPath) {
        var allowed = normalizePath(allowedPath);
        return currentPath === allowed || currentPath.startsWith("".concat(allowed, "/"));
    });
};
export var getRedirectPathItemsForRegion = function getRedirectPathItemsForRegion(region) {
    return sidebarItems.filter(function (item) {
        var _item$url;
        return isPathAllowedForRegion((_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : '', region);
    });
};
export var isListPage = function isListPage(path) {
    return NAVIGATION_PATHS.some(function (item) {
        return normalizePath(path) === normalizePath(item);
    });
};
